import mainTheme from './main';
import { colors } from '@material-ui/core';
const white = '#FFFFFF';
const black = '#000000';

export default {
  ...mainTheme,
  primary: {
    contrastText: white,
    dark: colors.pink[400],
    main: colors.pink[300],
    light: colors.pink[200]
  },
};